export default __webpack_public_path__ + "static/media/Top.c71ee8db.png";